export default {
    blacklist: 'บุคคลต้องห้าม',
    searchByName: 'ค้นหาโดยชื่อ',
    search: 'ค้นหา',
    create: 'สร้างบุคคลต้องห้าม',
    name: 'ชื่อ',
    contactNo: 'เบอร์โทรติดต่อ',
    reason: 'เหตุผล',
    createdDate: 'วันที่สร้าง',
    status: 'สถานะ',
    congratulation: 'ยินดีด้วย',
    deleteBlacklist: 'ลบบุคคลต้องห้าม',
    wantToDelete: 'คุณเเน่ใจว่าต้องการที่จะลบบุคคลต้องห้าม',
    blacklistIsDeleted: 'บุคคลต้องห้ามถูกลบแล้ว'
}
